import React from "react";

export class Addressee extends React.Component<any, any> {

    render() {
        let nameLine = this.props.shipping_name;
        let countryLine = this.props.shipping_country;

        if (this.props.shipping_contact_name && this.props.shipping_name &&
            this.props.shipping_contact_name !== this.props.shipping_name) {
            nameLine = this.props.shipping_name + ' (' + this.props.shipping_contact_name + ')';
        }

        if (this.props.shipping_state) {
            countryLine += ' (' + this.props.shipping_state + ')';
        }
        countryLine += ', ' + this.props.shipping_postcode + ' ' + this.props.shipping_city;

        // if (this.props.shipping_email || this.props.shipping_phone) {
        //     let contactLine = '';
        //     if (this.props.shipping_email || this.props.shipping_phone) {
        //         contactLine = this.props.shipping_email + ' / ' + this.props.shipping_phone;
        //     } else {
        //         contactLine = this.props.shipping_email || this.props.shipping_phone;
        //     }
        //
        //     return (<>
        //         {nameLine}<br/>
        //         {contactLine}<br/>
        //         {countryLine}
        //     </>);
        // }

        return (<>
            {nameLine}<br/>
            {countryLine}
        </>);
    }
}
